import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'

import GoogleAssetGroupForm from '../../../AdForms/GoogleAssetGroup/GoogleAssetGroupCreate/GoogleAssetGroupForm'

import { googleRightUploadAdDataSelector } from '../../../../../modules/selectors/rights'

import { ROUTE_PARAMS } from '../../../../../constants/routes'

const AssetGroupCreative = ({ onSuccessSubmit, formProgressItems }) => {
  const { campaign } = useSelector(googleRightUploadAdDataSelector)

  const handleSuccessUploadCreative = useCallback(() => {
    onSuccessSubmit(
      {
        [ROUTE_PARAMS.campaignId]: campaign.id
      },
      campaign['advertising_channel_type']
    )
  }, [campaign, onSuccessSubmit])

  return <GoogleAssetGroupForm onSuccessSubmit={handleSuccessUploadCreative} formProgressItems={formProgressItems} />
}

export default AssetGroupCreative
